import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button, Card, CardBody, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import DatatableLayoutPagination from "layouts/DatatableLayoutPagination";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useAppDispatch, useAppSelector } from "../../../redux/store/configureStore";
import { clearGetPermissionMenus, getPermissionMenus } from "../../../redux/handlers/permission/getPermissionMenus.handler";
import { clearGetPermissionDetail, getPermissionDetail } from "../../../redux/handlers/permission/getPermissionDetail.handler";
import { clearCreatePermission, createPermission } from "../../../redux/handlers/permission/createPermission.handler";
import { clearUpdatePermission, updatePermission } from "../../../redux/handlers/permission/updatePermission.handler";
var DEFAULT_MENU_PERMISSIONS = {
    view: 0,
    create: 0,
    edit: 0,
    delete: 0,
    export: 0
};
var DEFAULT_ACTION_PERMISSIONS = {
    create: 0,
    edit: 0,
    delete: 0,
    export: 0
};
var ACTION_OPTIONS = [
    {
        key: "create",
        label: "สร้าง",
        description: "อนุญาตให้สร้างรายการใหม่"
    },
    {
        key: "edit",
        label: "แก้ไข",
        description: "อนุญาตให้แก้ไขข้อมูลรายการ"
    },
    {
        key: "delete",
        label: "ยกเลิก",
        description: "อนุญาตให้ยกเลิกหรือลบรายการ"
    },
    {
        key: "export",
        label: "Export รายการ",
        description: "อนุญาตให้ส่งออกรายการ"
    }
];
var toPermissionValue = function(value) {
    return Number(value) === 1 ? 1 : 0;
};
var normalizeIdentifier = function(value) {
    var number = Number(value);
    return Number.isFinite(number) && value !== "" && value !== null ? number : value;
};
var unwrapApiPayload = function(response) {
    var payload = response;
    for(var index = 0; index < 4; index += 1){
        if (!payload || Array.isArray(payload) || typeof payload !== "object") {
            break;
        }
        var isRolePayload = payload.sys_role_id !== undefined || payload.sys_role_code !== undefined || payload.permissions !== undefined || payload.role !== undefined;
        if (isRolePayload || payload.data === undefined) break;
        payload = payload.data;
    }
    return payload;
};
var getApiRows = function(response) {
    if (Array.isArray(response === null || response === void 0 ? void 0 : response.data)) return response.data;
    return Array.isArray(response) ? response : [];
};
var normalizeMenu = function(menu) {
    return {
        sys_menu_id: normalizeIdentifier(menu === null || menu === void 0 ? void 0 : menu.sys_menu_id),
        sys_menu_name: (menu === null || menu === void 0 ? void 0 : menu.sys_menu_name) || "-",
        sys_menu_status: menu === null || menu === void 0 ? void 0 : menu.sys_menu_status
    };
};
var isActiveMenu = function(menu) {
    return (menu === null || menu === void 0 ? void 0 : menu.sys_menu_status) === "Enable";
};
var normalizeRolePermission = function(permission) {
    return {
        sys_menu_id: normalizeIdentifier(permission === null || permission === void 0 ? void 0 : permission.sys_menu_id),
        view: toPermissionValue(permission === null || permission === void 0 ? void 0 : permission.view),
        create: toPermissionValue(permission === null || permission === void 0 ? void 0 : permission.create),
        edit: toPermissionValue(permission === null || permission === void 0 ? void 0 : permission.edit),
        delete: toPermissionValue(permission === null || permission === void 0 ? void 0 : permission.delete),
        export: toPermissionValue(permission === null || permission === void 0 ? void 0 : permission.export)
    };
};
var PermissionRadio = function(param) {
    var checked = param.checked, name = param.name, onChange = param.onChange, ariaLabel = param.ariaLabel;
    return /*#__PURE__*/ _jsx(Form.Check.Input, {
        type: "radio",
        name: name,
        checked: checked,
        onChange: onChange,
        "aria-label": ariaLabel,
        style: {
            width: 20,
            height: 20,
            cursor: "pointer",
            accentColor: "#B00412"
        }
    });
};
export function PermissionCreate() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useParams = useParams(), permissionId = _useParams.dataId;
    var isEditMode = Boolean(permissionId);
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var modalContextRef = useRef({
        modalObj: modalObj,
        setModalObj: setModalObj
    });
    modalContextRef.current = {
        modalObj: modalObj,
        setModalObj: setModalObj
    };
    var getPermissionMenusReducer = useAppSelector(function(state) {
        return state.getPermissionMenusReducer;
    });
    var getPermissionDetailReducer = useAppSelector(function(state) {
        return state.getPermissionDetailReducer;
    });
    var createPermissionReducer = useAppSelector(function(state) {
        return state.createPermissionReducer;
    });
    var updatePermissionReducer = useAppSelector(function(state) {
        return state.updatePermissionReducer;
    });
    var _useState = _sliced_to_array(useState(false), 2), validated = _useState[0], setValidated = _useState[1];
    var _useState1 = _sliced_to_array(useState(permissionId || ""), 2), roleId = _useState1[0], setRoleId = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), permissionCode = _useState2[0], setPermissionCode = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), permissionName = _useState3[0], setPermissionName = _useState3[1];
    var _useState4 = _sliced_to_array(useState(2), 2), permissionLevel = _useState4[0], setPermissionLevel = _useState4[1];
    var _useState5 = _sliced_to_array(useState(1), 2), permissionStatus = _useState5[0], setPermissionStatus = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), menuList = _useState6[0], setMenuList = _useState6[1];
    var _useState7 = _sliced_to_array(useState({}), 2), permissionByMenu = _useState7[0], setPermissionByMenu = _useState7[1];
    var _useState8 = _sliced_to_array(useState(null), 2), selectedMenu = _useState8[0], setSelectedMenu = _useState8[1];
    var _useState9 = _sliced_to_array(useState(DEFAULT_ACTION_PERMISSIONS), 2), modalPermissions = _useState9[0], setModalPermissions = _useState9[1];
    var _useState10 = _sliced_to_array(useState(1), 2), pageId = _useState10[0], setPageId = _useState10[1];
    var _useState11 = _sliced_to_array(useState(10), 2), pageSize = _useState11[0], setPageSize = _useState11[1];
    var _useState12 = _sliced_to_array(useState({
        sortField: "sys_menu_id",
        sortValue: "asc"
    }), 2), sortModel = _useState12[0], setSortModel = _useState12[1];
    useEffect(function() {
        dispatch(getPermissionMenus(modalContextRef.current));
        if (isEditMode) {
            dispatch(getPermissionDetail({
                sys_role_id: parseInt(permissionId, 10)
            }, modalContextRef.current));
        }
        return function() {
            dispatch(clearGetPermissionMenus());
            dispatch(clearGetPermissionDetail());
            dispatch(clearCreatePermission());
            dispatch(clearUpdatePermission());
        };
    }, [
        dispatch,
        isEditMode,
        permissionId
    ]);
    useEffect(function() {
        if (getPermissionMenusReducer.data && !getPermissionMenusReducer.isError) {
            var menus = getApiRows(getPermissionMenusReducer.data).map(normalizeMenu).filter(isActiveMenu);
            setMenuList(menus);
        } else if (getPermissionMenusReducer.isError) {
            setMenuList([]);
        }
    }, [
        getPermissionMenusReducer
    ]);
    useEffect(function() {
        if (!getPermissionDetailReducer.data || getPermissionDetailReducer.isError) {
            return;
        }
        var responsePayload = unwrapApiPayload(getPermissionDetailReducer.data) || {};
        var payload = Array.isArray(responsePayload) ? responsePayload[0] || {} : responsePayload;
        var role = payload.role || payload.sysRole || payload;
        var permissions = Array.isArray(payload.permissions) ? payload.permissions : Array.isArray(role.permissions) ? role.permissions : [];
        var _role_sys_role_id;
        setRoleId((_role_sys_role_id = role.sys_role_id) !== null && _role_sys_role_id !== void 0 ? _role_sys_role_id : permissionId);
        setPermissionCode(role.sys_role_code || "");
        setPermissionName(role.sys_role_name || "");
        var _role_sys_role_level;
        setPermissionLevel(Number((_role_sys_role_level = role.sys_role_level) !== null && _role_sys_role_level !== void 0 ? _role_sys_role_level : 2));
        setPermissionStatus(toPermissionValue(role.sys_role_is_active));
        setPermissionByMenu(permissions.reduce(function(result, permission) {
            var normalized = normalizeRolePermission(permission);
            result[String(normalized.sys_menu_id)] = normalized;
            return result;
        }, {}));
    }, [
        getPermissionDetailReducer,
        permissionId
    ]);
    useEffect(function() {
        if (createPermissionReducer.isSuccess || updatePermissionReducer.isSuccess) {
            window.location.reload();
        }
    }, [
        createPermissionReducer.isSuccess,
        updatePermissionReducer.isSuccess
    ]);
    var menuData = useMemo(function() {
        return menuList.map(function(menu) {
            return _object_spread_props(_object_spread({}, menu), {
                permissions: _object_spread({}, DEFAULT_MENU_PERMISSIONS, permissionByMenu[String(menu.sys_menu_id)] || {})
            });
        });
    }, [
        menuList,
        permissionByMenu
    ]);
    var sortedItems = useMemo(function() {
        var sortField = sortModel.sortField, sortValue = sortModel.sortValue;
        var direction = sortValue === "desc" ? -1 : 1;
        return _to_consumable_array(menuData).sort(function(firstItem, secondItem) {
            var firstValue = firstItem === null || firstItem === void 0 ? void 0 : firstItem[sortField];
            var secondValue = secondItem === null || secondItem === void 0 ? void 0 : secondItem[sortField];
            if (firstValue === secondValue) return 0;
            if (firstValue === null || firstValue === undefined) return 1;
            if (secondValue === null || secondValue === undefined) return -1;
            return firstValue > secondValue ? direction : -direction;
        });
    }, [
        menuData,
        sortModel
    ]);
    var tableItems = useMemo(function() {
        var startIndex = (pageId - 1) * pageSize;
        return sortedItems.slice(startIndex, startIndex + pageSize);
    }, [
        pageId,
        pageSize,
        sortedItems
    ]);
    var totalAmount = sortedItems.length;
    var totalPage = Math.max(1, Math.ceil(totalAmount / pageSize));
    var isLoading = getPermissionMenusReducer.isFetching || isEditMode && getPermissionDetailReducer.isFetching;
    var isSaving = createPermissionReducer.isFetching || updatePermissionReducer.isFetching;
    useEffect(function() {
        if (pageId > totalPage) setPageId(totalPage);
    }, [
        pageId,
        totalPage
    ]);
    var updateMenuPermission = function(menuId, patch) {
        var key = String(menuId);
        setPermissionByMenu(function(currentValue) {
            return _object_spread_props(_object_spread({}, currentValue), _define_property({}, key, _object_spread(_object_spread_props(_object_spread({}, DEFAULT_MENU_PERMISSIONS, currentValue[key] || {}), {
                sys_menu_id: menuId
            }), patch)));
        });
    };
    var handleOpenSetting = function(menu) {
        var setting = {
            sys_menu_id: menu.sys_menu_id,
            sys_menu_name: menu.sys_menu_name,
            create: toPermissionValue(menu.permissions.create),
            edit: toPermissionValue(menu.permissions.edit),
            delete: toPermissionValue(menu.permissions.delete),
            export: toPermissionValue(menu.permissions.export)
        };
        setSelectedMenu(setting);
        setModalPermissions({
            create: setting.create,
            edit: setting.edit,
            delete: setting.delete,
            export: setting.export
        });
    };
    var handleCloseSetting = function() {
        setSelectedMenu(null);
        setModalPermissions(DEFAULT_ACTION_PERMISSIONS);
    };
    var handleSaveSetting = function() {
        if (!selectedMenu) return;
        updateMenuPermission(selectedMenu.sys_menu_id, modalPermissions);
        handleCloseSetting();
    };
    var handleChangeRowsPerPage = function(newPageSize) {
        setPageSize(newPageSize);
        setPageId(1);
    };
    var handleSort = function(column, sortDirection) {
        if (!(column === null || column === void 0 ? void 0 : column.sortField)) return;
        setSortModel({
            sortField: column.sortField,
            sortValue: sortDirection
        });
        setPageId(1);
    };
    var handleSubmit = function(event) {
        event.preventDefault();
        event.stopPropagation();
        var form = event.currentTarget;
        setValidated(true);
        if (!form.checkValidity() || isSaving || menuData.length === 0) return;
        var payload = _object_spread_props(_object_spread({}, isEditMode && {
            sys_role_id: normalizeIdentifier(roleId)
        }), {
            sys_role_code: permissionCode.trim(),
            sys_role_name: permissionName.trim(),
            sys_role_level: isEditMode ? Number(permissionLevel) : 2,
            sys_role_is_active: permissionStatus,
            permissions: menuData.map(function(menu) {
                return {
                    sys_menu_id: normalizeIdentifier(menu.sys_menu_id),
                    view: toPermissionValue(menu.permissions.view),
                    create: toPermissionValue(menu.permissions.create),
                    edit: toPermissionValue(menu.permissions.edit),
                    delete: toPermissionValue(menu.permissions.delete),
                    export: toPermissionValue(menu.permissions.export)
                };
            })
        });
        if (isEditMode) {
            dispatch(updatePermission(payload, modalContextRef.current));
        } else {
            dispatch(createPermission(payload, modalContextRef.current));
        }
    };
    var columns = [
        {
            name: "เมนู",
            selector: function(row) {
                return row.sys_menu_name;
            },
            sortField: "sys_menu_name",
            sortable: true,
            minWidth: "260px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx("span", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: row.sys_menu_name
                });
            }
        },
        {
            name: "ห้ามเข้าดู",
            selector: function(row) {
                return row.permissions.view;
            },
            center: "true",
            minWidth: "150px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(PermissionRadio, {
                    name: "menu-access-".concat(row.sys_menu_id),
                    checked: row.permissions.view !== 1,
                    onChange: function() {
                        return updateMenuPermission(row.sys_menu_id, {
                            view: 0
                        });
                    },
                    ariaLabel: "ห้ามเข้าดูเมนู ".concat(row.sys_menu_name)
                });
            }
        },
        {
            name: "เข้าดูได้",
            selector: function(row) {
                return row.permissions.view;
            },
            center: "true",
            minWidth: "150px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(PermissionRadio, {
                    name: "menu-access-".concat(row.sys_menu_id),
                    checked: row.permissions.view === 1,
                    onChange: function() {
                        return updateMenuPermission(row.sys_menu_id, {
                            view: 1
                        });
                    },
                    ariaLabel: "เข้าดูเมนู ".concat(row.sys_menu_name, " ได้")
                });
            }
        },
        {
            name: "ตั้งค่า",
            selector: function(row) {
                return row.sys_menu_id;
            },
            center: "true",
            width: "150px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(Button, {
                    type: "button",
                    variant: "",
                    className: "btn-st-7 px-3 py-2",
                    onClick: function() {
                        return handleOpenSetting(row);
                    },
                    children: "ตั้งค่า"
                });
            }
        }
    ];
    var pageTitle = isEditMode ? "แก้ไขสิทธิ์ผู้ใช้งาน" : "สร้างสิทธิ์ผู้ใช้งาน";
    return /*#__PURE__*/ _jsxs("div", {
        className: "pagezoom",
        children: [
            /*#__PURE__*/ _jsx("nav", {
                "aria-label": "breadcrumb",
                className: "mt-2",
                children: /*#__PURE__*/ _jsxs("ol", {
                    className: "breadcrumb fs-16 ps-0 mb-1",
                    children: [
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item",
                            children: /*#__PURE__*/ _jsx(Link, {
                                to: "/setting/master",
                                className: "tc-7 text-decoration-none",
                                children: "ตั้งค่า"
                            })
                        }),
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item",
                            children: /*#__PURE__*/ _jsx(Link, {
                                to: "/setting/permission",
                                className: "tc-7 text-decoration-none",
                                children: "กำหนดสิทธิ์ผู้ใช้งาน"
                            })
                        }),
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item active tc-1",
                            "aria-current": "page",
                            children: pageTitle
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("h1", {
                className: "fs-24 mb-3",
                children: pageTitle
            }),
            /*#__PURE__*/ _jsxs(Form, {
                noValidate: true,
                validated: validated,
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ _jsx(Card, {
                        className: "card-st-2 mb-3",
                        children: /*#__PURE__*/ _jsxs(CardBody, {
                            children: [
                                /*#__PURE__*/ _jsxs("h2", {
                                    className: "fs-20 mb-4",
                                    children: [
                                        isEditMode ? "แก้ไข" : "สร้าง",
                                        "สิทธิ์การใช้งาน SYSTEM"
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Row, {
                                    className: "align-items-end g-3",
                                    children: [
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: 5,
                                            lg: 4,
                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                controlId: "permission-code",
                                                children: [
                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                        children: [
                                                            "รหัสสิทธิ์การใช้งาน ",
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "text-danger",
                                                                children: "*"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                        required: true,
                                                        type: "text",
                                                        value: permissionCode,
                                                        onChange: function(event) {
                                                            return setPermissionCode(event.target.value);
                                                        },
                                                        placeholder: "ระบุรหัสสิทธิ์การใช้งาน",
                                                        disabled: isLoading || isSaving
                                                    }),
                                                    /*#__PURE__*/ _jsx(Form.Control.Feedback, {
                                                        type: "invalid",
                                                        children: "กรุณาระบุรหัสสิทธิ์การใช้งาน"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: 5,
                                            lg: 4,
                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                controlId: "permission-name",
                                                children: [
                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                        children: [
                                                            "ชื่อสิทธิ์ใช้งาน ",
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "text-danger",
                                                                children: "*"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                        required: true,
                                                        type: "text",
                                                        value: permissionName,
                                                        onChange: function(event) {
                                                            return setPermissionName(event.target.value);
                                                        },
                                                        placeholder: "ระบุชื่อสิทธิ์ใช้งาน",
                                                        disabled: isLoading || isSaving
                                                    }),
                                                    /*#__PURE__*/ _jsx(Form.Control.Feedback, {
                                                        type: "invalid",
                                                        children: "กรุณาระบุชื่อสิทธิ์ใช้งาน"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: "auto",
                                            className: "d-flex align-items-center pb-md-2",
                                            children: /*#__PURE__*/ _jsx(Form.Check, {
                                                type: "switch",
                                                id: "permission-status",
                                                className: "d-inline-flex align-items-center gap-2 m-0",
                                                style: {
                                                    width: "fit-content",
                                                    whiteSpace: "nowrap"
                                                },
                                                label: permissionStatus === 1 ? "เปิดใช้งาน" : "ปิดใช้งาน",
                                                checked: permissionStatus === 1,
                                                onChange: function(event) {
                                                    return setPermissionStatus(event.target.checked ? 1 : 0);
                                                },
                                                disabled: isLoading || isSaving
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Card, {
                        className: "card-st-2",
                        children: /*#__PURE__*/ _jsx("div", {
                            style: {
                                overflowX: "auto"
                            },
                            children: /*#__PURE__*/ _jsx(DatatableLayoutPagination, {
                                item: tableItems,
                                columns: columns,
                                isSelectRows: false,
                                currentPage: pageId,
                                currentPageSize: pageSize,
                                onChangePage: setPageId,
                                onChangePageSize: handleChangeRowsPerPage,
                                totalPage: totalPage,
                                totalAmount: totalAmount,
                                sortModel: sortModel,
                                onChangeSort: setSortModel,
                                handleSort: handleSort,
                                loading: isLoading
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Row, {
                        className: "justify-content-end g-2 mt-3 mb-4",
                        children: [
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                sm: "auto",
                                children: /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    variant: "outline-secondary",
                                    className: "px-4 w-100",
                                    onClick: function() {
                                        return navigate("/setting/permission");
                                    },
                                    disabled: isSaving,
                                    children: "ยกเลิก"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                sm: "auto",
                                children: /*#__PURE__*/ _jsxs(Button, {
                                    type: "submit",
                                    variant: "",
                                    className: "btn-st-7 px-4 w-100",
                                    disabled: isLoading || isSaving || menuData.length === 0,
                                    children: [
                                        isSaving && /*#__PURE__*/ _jsx(Spinner, {
                                            animation: "border",
                                            size: "sm",
                                            className: "me-2"
                                        }),
                                        isSaving ? "กำลังบันทึก" : "บันทึก"
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Modal, {
                show: Boolean(selectedMenu),
                onHide: handleCloseSetting,
                size: "lg",
                centered: true,
                scrollable: true,
                children: [
                    /*#__PURE__*/ _jsx(Modal.Header, {
                        closeButton: true,
                        className: "modal-header-danger",
                        children: /*#__PURE__*/ _jsxs(Modal.Title, {
                            className: "fs-18",
                            children: [
                                "ตั้งค่าสิทธิ์ ",
                                (selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.sys_menu_name) || ""
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Modal.Body, {
                        className: "p-0",
                        children: [
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "g-0 fw-semibold border-bottom bg-light py-3 px-3",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        children: "การทำงาน"
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 3,
                                        className: "text-center",
                                        children: "อนุญาต"
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 3,
                                        className: "text-center",
                                        children: "ไม่อนุญาต"
                                    })
                                ]
                            }),
                            ACTION_OPTIONS.map(function(action) {
                                return /*#__PURE__*/ _jsxs(Row, {
                                    className: "g-0 align-items-center border-bottom py-3 px-3",
                                    children: [
                                        /*#__PURE__*/ _jsxs(Col, {
                                            xs: 6,
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "fw-semibold",
                                                    children: action.label
                                                }),
                                                /*#__PURE__*/ _jsx("small", {
                                                    className: "text-secondary",
                                                    children: action.description
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 3,
                                            className: "d-flex justify-content-center",
                                            children: /*#__PURE__*/ _jsx(PermissionRadio, {
                                                name: "action-".concat(selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.sys_menu_id, "-").concat(action.key),
                                                checked: modalPermissions[action.key] === 1,
                                                onChange: function() {
                                                    return setModalPermissions(function(currentValue) {
                                                        return _object_spread_props(_object_spread({}, currentValue), _define_property({}, action.key, 1));
                                                    });
                                                },
                                                ariaLabel: "อนุญาตให้".concat(action.label)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 3,
                                            className: "d-flex justify-content-center",
                                            children: /*#__PURE__*/ _jsx(PermissionRadio, {
                                                name: "action-".concat(selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.sys_menu_id, "-").concat(action.key),
                                                checked: modalPermissions[action.key] !== 1,
                                                onChange: function() {
                                                    return setModalPermissions(function(currentValue) {
                                                        return _object_spread_props(_object_spread({}, currentValue), _define_property({}, action.key, 0));
                                                    });
                                                },
                                                ariaLabel: "ไม่อนุญาตให้".concat(action.label)
                                            })
                                        })
                                    ]
                                }, action.key);
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Modal.Footer, {
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "outline-secondary",
                                onClick: handleCloseSetting,
                                children: "ยกเลิก"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "",
                                className: "btn-st-7 px-4",
                                onClick: handleSaveSetting,
                                children: "บันทึก"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
export default PermissionCreate;
